import { Badge } from '@/components/ui'
import type { ChainRunTriggerSource } from '@/types'

interface Props {
  triggerSource: ChainRunTriggerSource
}

export function AutomaticStartBadge({ triggerSource }: Props) {
  if (triggerSource !== 'AzureDevOpsIngestion') return null

  return (
    <Badge
      variant="outline"
      className="text-xs shrink-0"
      title="Started automatically when the item was ingested from Azure DevOps"
      data-testid="chain-run-automatic-badge"
    >
      Automatic
    </Badge>
  )
}
